import {CITY_ARE_LOADING, CITY_HAVE_ERROR, CITY_FETCH_DATA_SUCCESS} from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function CityReducer (state = initialState, action) {
    switch (action.type) {
        case CITY_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case CITY_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case CITY_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.city,
                loading:false,
            }

        default:
            return state;
    }
}
